import React from 'react';
import { Empty } from 'antd';
import LeaderboardPage from '../../pages/LeaderboardPage';

/**
 * The leaderboard's Goals view for this campaign: how many agents sit in each
 * band per metric, and each agent's level.
 *
 * Scoped by campaign AND team. An agent belongs to one team but may take
 * another campaign's calls, so the two cut across each other and the
 * intersection is the question: how are this team's agents doing on this
 * campaign.
 *
 * A month, not the page's date range. These are a month's standing against
 * that month's goals -- goals are time-bounded, so a range spanning a change
 * would have no single answer -- which is why the range picker is hidden on
 * this tab and the month dropdown comes from the leaderboard itself.
 */
export default function AgentGoalsTab({ campaignId, teamId }) {
  if (!campaignId) {
    return <Empty description="Select a campaign" image={Empty.PRESENTED_IMAGE_SIMPLE} style={{ marginTop: 40 }} />;
  }
  return <LeaderboardPage embedded campaignId={campaignId} teamId={teamId} />;
}
